module.exports = __webpack_public_path__ + "static/media/work5.9af0312d.webp";